/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { StoryElement, WithLazy } from "@quintype/components";
import { format } from "date-fns";
import { kn } from "date-fns/locale";
import Tags from "../story-elements/tags";
import MoreNews from "../story-elements/more-news";
import AlsoRead from "../story-elements/also-read";
import Slideshow from "../story-elements/slide-show";
import Attachment from "../story-elements/attachment";
import FactCheckView from "../story-elements/fact-check";
import PodcastBody from "../story-elements/podcast-body";
import ImageGallery from "../story-elements/image-gallery";
import SponsoredTag from "../story-elements/sponsored-tag";
import MovieReviewView from "../story-elements/movie-review";
import GadgetReviewView from "../story-elements/gadget-review";
import ReferenceElement from "../story-elements/reference-element";

import { AdContainer } from "../../ads";
import TaboolaAd from "../../ads/taboola-ad";

import SocialMediaShare from "../../molecules/social-media-share";
import BlockQuoteIcon from "../../atoms/icons/blockquote-icon";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import PromotionalMessage from "./promotional-message";
import ImagewithCaption from "../../molecules/Image-caption";

import { storyPageBodyAd } from "../../../components/helper/utils";

import "./story-elements.m.css";

const getAlsoReadCards = (card) => {
  return card["story-elements"]?.filter((element) => element.subtype == "also-read");
};
const getElementsWithoutAlsoRead = (card) => {
  return card["story-elements"]?.filter((element) => element.subtype !== "also-read");
};

const getElements = (element, story, card, elementIndex, cardIndex) => {
  const elementType = element.type;
  const [toggleSharing, setToggleSharing] = useState(false);
  const sharingHandler = () => {
    setToggleSharing(!toggleSharing);
  };

  if (element.metadata?.["promotional-message"] === true) {
    return null;
  }

  if (element.type === "text" && cardIndex === 0 && elementIndex === 0) {
    return (
      <div id="text-element-with-ad">
        <StoryElement element={element} key={element.id} story={story} />
      </div>
    );
  }

  switch (element.subtype) {
    case "attachment": {
      return <Attachment element={element} />;
    }
    case "references": {
      const referenceObj = get(element, ["story-elements"], []);
      return referenceObj.map((element, index) => <ReferenceElement element={element} key={index} />);
    }
    case "image-gallery": {
      if (element.metadata.type === "gallery") {
        return <WithLazy margin="50px">{() => <ImageGallery element={element} story={story} />}</WithLazy>;
      }

      if (element.metadata.type === "slideshow") {
        return <WithLazy margin="50px">{() => <Slideshow story={story} element={element} />}</WithLazy>;
      }
      break;
    }
    case "blockquote": {
      return (
        <div styleName="blockquote-wrapper">
          <BlockQuoteIcon />
          <StoryElement element={element} key={element.id} story={story} />
        </div>
      );
    }
    case "quote": {
      return (
        <div styleName="quote-wrapper" className="exclusive-wrapper">
          <div styleName="quote-contents" className="exclusive-contents">
            <img src="/icons/quoteicon.png" styleName="quote-icon" />
            <StoryElement element={element} key={element.id} story={story} />
          </div>
        </div>
      );
    }
    default:
      if (story["story-template"] === "photo" && elementType === "image") {
        return (
          <div styleName="share-wrapper">
            {story["story-template"] === "photo" && elementType === "image" && (
              <StoryElement
                renderTemplates={{ image: ImagewithCaption }}
                element={element}
                key={element.id}
                story={story}
              />
            )}
          </div>
        );
      } else {
        return (
          <div styleName="share-wrapper">
            {story["story-template"] !== "podcast" ? (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            ) : elementType !== "jsembed" ? (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            ) : element.subtype === "" || element.subtype === null ? (
              console.log("element.subtype ignored:>:>:>:>:>", elementType, element.subtype)
            ) : (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            )}
          </div>
        );
      }
  }
};

export const StoryCard = ({ story, card, cardIndex, index }) => {
  const alsoReads = getAlsoReadCards(card);
  const elements = alsoReads.length ? getElementsWithoutAlsoRead(card) : card["story-elements"];

  return (
    <div styleName="story-card" key={card.id} id={card.id} className="story-card">
      {alsoReads && <AlsoRead elements={alsoReads} story={story} />}
      {elements.map((element, elementIndex) => {
        return (
          <>
            {getElements(element, story, card, elementIndex, cardIndex)}
            {cardIndex === 0 && elementIndex === 0 && element.type !== "text" ? (
              <div styleName="ad-wrapper" key={index}>
                <AdContainer
                  AdClassName="standard-336x280"
                  id="div-gpt-ad-1675837516069-0"
                  desktop="PV_Desktop_AP_Mid"
                  mobile="PV_MWeb_AP_Mid"
                />
              </div>
            ) : null}
          </>
        );
      })}
    </div>
  );
};

const StoryElements = ({
  story,
  index,
  cards,
  isPodcast = false,
  isFactCheck,
  isMovieReview,
  isGadgetReview,
  isSponsoredStory
}) => {
  const template = story["story-template"] ? story["story-template"] : "text";

  useEffect(() => {
    template !== "sponsored" && storyPageBodyAd(story);
  }, []);

  return (
    <div styleName="wrapper">
      {isMovieReview && <MovieReviewView story={story} />}
      {isGadgetReview && <GadgetReviewView story={story} />}
      <div id={`story-content-${story.id}`} className="story-cards">
        {cards.map((card, cardIndex) => (
          <StoryCard card={card} story={story} key={index} cardIndex={cardIndex} index={index} />
        ))}
      </div>
      {isPodcast && story["first-published-at"] > 1682569800000 ? <PodcastBody /> : null}
      {isFactCheck && <FactCheckView story={story} />}
      <Tags story={story} />
      <PromotionalMessage story={story} />
      {isSponsoredStory && <SponsoredTag />}
      {index === 0 ? (
        <>
          <div styleName="ad-wrapper" className="hide-mobile">
            <AdContainer
              AdClassName="standard-970x90"
              id="div-gpt-ad-1675837241937-0"
              desktop="PV_Desktop_AP_Leaderboard_Bottom"
            />
          </div>
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id="div-gpt-ad-1675837544367-0" mobile="PV_MWeb_AP_Bottom" />
          </div>
        </>
      ) : null}
      {template === "sponsored" || template === "live-blog" ? null : (
        <div className="vuukle-widget">
          <div id={`vuukle-comments-${story.id}`} />
        </div>
      )}
      <div className="more-news-section">
        <MoreNews story={story} />
      </div>
      <TaboolaAd
        container={`'taboola-below-article-${story.id}`}
        placement="Below Article Thumbnails"
        mode="thumbnails-e"
      />
      {template !== "sponsored" && (
        <div styleName="temp-ad">
          <AdContainer
            AdClassName="standard-336x280"
            id={`div-gpt-ad-1675837175211-0`}
            desktop="PV_Desktop_AP_Mid"
            className="hide-mobile"
          />
          <AdContainer
            AdClassName="standard-336x280"
            id={`div-gpt-ad-1675837516069-0`}
            mobile="PV_MWeb_AP_Mid"
            className="hide-desktop"
          />
        </div>
      )}
    </div>
  );
};

StoryElements.defaultProps = {
  isPodcast: false,
  isFactCheck: false,
  isMovieReview: false,
  isGadgetReview: false,
  isSponsoredStory: false
};

export default StoryElements;
